import {Directive, ElementRef, Input} from '@angular/core';
import {config} from "rxjs";

@Directive({
  selector: '[documentStatusHighlight]',
  standalone: true
})
export class DocumentStatusHighlightDirective {
  @Input()
  set documentStatusHighlight(status: string) {
    // this.el.nativeElement.style.height = `18px`;
    this.el.nativeElement.style.padding = `0 5px`;
    if (this.config[status]) {
      this.el.nativeElement.style.borderLeft = `4px solid ${this.config[status]}`;
    } else {
      this.el.nativeElement.style.borderLeft = `4px solid transparent`;
    }
  }
  
  config: {[key: string]: string} = {
    DRAFT: '#C7C7C7',
    CONFIRMED: '#00C95C',
    CANCELLED: '#FC5C5C'
  }

  constructor(private el: ElementRef) { }

}
